import { GlIcon, GlButton, GlLink, GlCollapse } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { escape } from 'lodash-es';
import LocalStorageSync from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/local_storage_sync.vue?vue3';
import { s__, sprintf } from '~/locale';
import SafeHtml from '~/vue_shared/directives/safe_html';
export default {
    name: 'WikiSidebarEntry',
    components: {
        GlIcon,
        GlLink,
        GlButton,
        GlCollapse,
        LocalStorageSync
    },
    directives: {
        SafeHtml
    },
    inject: [
        'canCreate'
    ],
    props: {
        page: {
            type: Object,
            required: true
        },
        searchTerm: {
            type: String,
            default: '',
            required: false
        }
    },
    data () {
        return {
            isCollapsed: false
        };
    },
    computed: {
        plusButtonTooltip () {
            return sprintf(s__('Wiki|Create a new page under "%{page_title}"'), {
                page_title: this.page.title
            });
        },
        currentPath () {
            return window.location.pathname;
        },
        pageTitle () {
            if (this.page.title === 'home') return s__('Wiki|Home');
            return this.page.title;
        }
    },
    methods: {
        toggleCollapsed () {
            this.isCollapsed = !this.isCollapsed;
        },
        highlight (text) {
            if (!this.searchTerm) {
                return escape(text);
            }
            const escapedText = escape(text);
            const regex = new RegExp(`(${this.searchTerm})`, 'i');
            return `${escapedText.replace(regex, (match)=>`<span class="gl-bg-status-warning">${match}</span>`)}`;
        }
    },
    safeHtmlConfig: {
        ALLOWED_TAGS: [
            'span'
        ]
    }
};
